import { PropsWithChildren } from "react";

import Sidebar from "@components/sidebar/sidebar";

const ViewOptionsSidebar = ({
  title = "View Options",
  onClose,
  additionalActions,
  children,
}: PropsWithChildren<{
  title?: string;
  onClose: () => void;
  additionalActions?: JSX.Element;
}>) => {
  return (
    <Sidebar
      title={title}
      onClose={onClose}
      additionalActions={additionalActions}
    >
      {children}
    </Sidebar>
  );
};

export default ViewOptionsSidebar;
